import moment from 'moment';
import { Message } from 'antd';
import { getSchedules, getSchedulesStatus, getSchedulesList, translation } from '../../api/index.js';


let getCourses = async (data, dispatch) => {
  let res = await getSchedules(data);
  if (res.code === 200) {
    dispatch({type: 'SET_COURSE', payload: { courseList: res.output }});
    return;
  }
  Message.warn(res.tip);
}

let getMonth = async (dispatch, date = moment()) => {
  let res = await getSchedulesList({
      start_at: moment(date).startOf('month').format('YYYY-MM-DD'),
      end_at: moment(date).endOf('month').format('YYYY-MM-DD'),
      offset: new Date().getTimezoneOffset()
    })
  if (res.code === 200) {
    let obj = {};
    const arr = Object.keys(res.output);
    for (let i = 0; i < Object.keys(res.output).length; i += 1) {
      obj[parseInt(arr[i].slice(-2), 10)] = 1
    }
    dispatch({type: 'SET_COURSE', payload: { calendar: obj }});
  } else {
    Message.warn(res.tip);
  }
}

export function getCourseList(data) {
  return async (dispatch) => {
    let response = await getSchedulesStatus(data.offset)
    if (response.code === 200) {
      dispatch({type: 'SET_COURSE', payload: { status: true }});
    } else {
      dispatch({type: 'SET_COURSE', payload: { status: false }});
    }
    getCourses(data, dispatch);
    getMonth(dispatch, data.date);
  }
}

export function translate(data, key) {
  return async (dispatch) => {
    let response = await translation(data)
    if (response.code === 200) {
      dispatch({type: 'SET_TRANSLATION', payload: { [key]: response.output.translation[0] }});
      return;
    }
  }
}

export function translateClear(data, key) {
  return (dispatch) => {
    dispatch({type: 'SET_TRANSLATION', payload: {
      excellent: '',
      homework: '',
      insufficiency: ''
    }});
  }
}

export function getCourse(data) {
  return (dispatch) => {
    getCourses(data, dispatch);
  }
}

export function getMonthData(data) {
  return async (dispatch) => {
    getMonth(dispatch, data);
  }
}
    


// WEBPACK FOOTER //
// ./src/store/actions/schedule.js